import { useEffect, useState } from "react";
import supabase from "./supabase";
import "./app.css";

const CATEGORIES = [
  { name: "all", color: "#a8a29e" },
  { name: "movie", color: "#3b82f6" },
  { name: "series", color: "#16a34a" },
  { name: "show", color: "#ef4488" },
  { name: "music", color: "#eab308" },
  { name: "others", color: "#db6643" },
];

function App() {
  const [showForm, setShowForm] = useState(false);
  const [aBestList, setBest] = useState([]);
  const [isSpinning, setSpinning] = useState(false);
  const [actualCategory, setActualCategory] = useState("all");

  const [clientIP, setClientIP] = useState("");

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => setClientIP(data.ip));
  }, []);

  useEffect(
    function () {
      async function getBest() {
        setSpinning(true);

        let query = supabase.from("aBest").select("*");

        if (actualCategory !== "all")
          query = query.eq("category", actualCategory);

        const { data: aBest, error } = await query;

        if (!error) {
          // order the list by different in like and dislike

          setBest(
            aBest.sort((b, a) => {
              const DifferentA = a.rating_plus - a.rating_neg;
              const DifferentB = b.rating_plus - b.rating_neg;
              return DifferentA - DifferentB;
            })
          );
        } else alert(`sorry can't get the data try again`);
        setSpinning(false);
      }
      getBest();
    },
    [actualCategory]
  );

  return (
    <>
      <Header
        showForm={showForm}
        setShowForm={setShowForm}
        aBestList={aBestList}
        setBest={setBest}
        clientIP={clientIP}
      />

      {showForm ? (
        <NewBestForm setShowForm={setShowForm} setBest={setBest} />
      ) : null}

      <main className="main">
        <Category
          setCategory={setActualCategory}
          actualCategory={actualCategory}
        />
        {isSpinning ? (
          <Spinning />
        ) : (
          <BestList aBest={aBestList} setBest={setBest} clientIP={clientIP} />
        )}
      </main>

      <Footer />
    </>
  );
}

function Header({ showForm, setShowForm, aBestList, setBest, clientIP }) {
  const [textInput, setTextInput] = useState("");
  function handlerSearch(e) {
    e.preventDefault();
    setTextInput(e.target.value);

    if (textInput !== "") {
      const orderByMach = aBestList.slice().sort((a, b) => {
        if (a.text.toLowerCase().includes(textInput)) {
          return -1;
        } else if (b.text.toLowerCase().includes(textInput)) {
          return 1;
        }

        return 0;
      });
      setBest(orderByMach);
    }
  }

  return (
    <header className="header">
      <svg className="logo" width="20" height="20" viewBox="0 0 20 20">
        <title>logo</title>
        <path d="M17 12h-6v4h1v4h-4v-4h1v-4h-6v4h1v4h-4v-4h1v-4c0-1.105 0.895-2 2-2v0h6v-4h-2v-6h6v6h-2v4h6c1.105 0 2 0.895 2 2v0 4h1v4h-4v-4h1v-4z"></path>
      </svg>

      <h1 className="headerText">
        Best <span>of the</span> Best
      </h1>
      <input
        value={textInput}
        type="text"
        placeholder="🔎 search favorite best"
        onChange={handlerSearch}
      />
      <button
        className="addBest btn"
        onClick={() => setShowForm((form) => !form)}
      >
        {showForm ? "Close" : "Add your Best"}
      </button>
    </header>
  );
}

function NewBestForm(props) {
  const { setBest, setShowForm } = props;
  const [text, setText] = useState("");
  const [source, setSource] = useState("");
  const [category, setCategory] = useState("");
  const [loadingForm, setLoadingForm] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();

    if (text && text.length <= 30 && source && category) {
      setLoadingForm(true);
      const { data: newBest, error } = await supabase
        .from("aBest")
        .insert([{ text, source, category, ips: [] }])
        .select();

      if (!error) setBest((bests) => [...bests, newBest[0]]);
    } else return;

    setText("");
    setSource("");
    setCategory("");
    setLoadingForm(true);
    setShowForm(false);
  }

  return (
    <form className="best-form" onSubmit={handleSubmit}>
      <input
        value={text}
        type="text"
        placeholder="What you things is the Best ?"
        onChange={(e) => setText(e.target.value)}
      />
      <span>{30 - text.length}</span>
      <input
        value={source}
        type="text"
        placeholder="add a source of the trailer!"
        onChange={(e) => setSource(e.target.value)}
      />
      <select value={category} onChange={(e) => setCategory(e.target.value)}>
        <option value="">category:</option>
        {CATEGORIES.map((cat) => {
          if (cat.name !== "all") {
            return (
              <option key={cat.name} value={cat.name}>
                {cat.name}
              </option>
            );
          } else return "";
        })}
      </select>

      <button className="btn" disabled={loadingForm}>
        Post
      </button>
    </form>
  );
}

function Category({ setCategory, actualCategory }) {
  return (
    <aside>
      <ul className="categories">
        {CATEGORIES.map((cat) => (
          <li
            key={cat.name}
            className={cat.name === actualCategory ? "activeCat" : ""}
          >
            <button
              onClick={() => setCategory(cat.name)}
              className="btn btn-categories"
              style={{
                background: `linear-gradient(90deg, #1a014379,${cat.color} , #1a014379)`,
              }}
            >
              {cat.name}
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
}

function BestList({ aBest, setBest, clientIP }) {
  const [actualPage, setActualPage] = useState(1);
  const itemPerPage = 5;
  const startIndex = (actualPage - 1) * itemPerPage;
  const endIndex = startIndex + itemPerPage;
  const aBestListPagination = aBest.slice(startIndex, endIndex);

  function handlePaginationNext() {
    if (actualPage < Math.ceil(aBest.length / itemPerPage))
      setActualPage(actualPage + 1);
  }
  function handlePaginationBack() {
    if (actualPage <= Math.ceil(aBest.length / itemPerPage) && actualPage > 1)
      setActualPage(actualPage - 1);
  }

  if (aBest.length === 0) {
    return (
      <p className="lengthOfBest">
        There not Best for this Category please add your own! ={">"} (click on
        ADD YOUR BEST)
      </p>
    );
  }

  return (
    <section>
      <ul className="aBests-list">
        {aBestListPagination.map((best, index) => (
          <Best
            key={best.id}
            bestObj={best}
            setBest={setBest}
            clientIP={clientIP}
            index={index}
          />
        ))}
      </ul>
      {Math.ceil(aBest.length / itemPerPage) > 1 ? (
        <div className="pagination">
          <button className="btn" onClick={handlePaginationBack}>
            Go to Back
          </button>
          <span>
            page {actualPage} of {Math.ceil(aBest.length / itemPerPage)}
          </span>
          <button className="btn" onClick={handlePaginationNext}>
            Go to Next
          </button>
        </div>
      ) : null}

      <p className="lengthOfBest">
        There are {aBest.length} Best in our database. add your best!
      </p>
    </section>
  );
}

function Best({ bestObj, setBest, clientIP }) {
  const [isLoading, setLoading] = useState(false);
  const [alreadyVoteOn, setAlreadyVoteOn] = useState(
    bestObj.ips.some((ip) => ip === clientIP)
  );

  async function handleVote(columnName) {
    setLoading(true);
    const { data: updateBest, error } = await supabase
      .from("aBest")
      .update({
        [columnName]: bestObj[columnName] + 1,
        ips: [...bestObj.ips, clientIP],
      })
      .eq("id", bestObj.id)
      .select();

    setLoading(false);
    setAlreadyVoteOn(true);

    if (!error)
      setBest((bests) =>
        bests.map((b) => (b.id === bestObj.id ? updateBest[0] : b))
      );
  }

  return (
    <li className="aBest">
      <p>{bestObj.text}</p>
      <a
        className="source"
        href={bestObj.source}
        target="_blank"
        rel="noreferrer"
      >
        (Trailer)
      </a>
      <span
        className="tag"
        style={{
          backgroundColor: CATEGORIES.find(
            (cat) => cat.name === bestObj.category
          ).color,
        }}
      >
        {bestObj.category}
      </span>
      <div className="ratings-btn-box">
        {alreadyVoteOn ? <span className="alreadyVoted">voted</span> : null}
        <button
          className="ratings-btn"
          onClick={() => handleVote("rating_plus")}
          disabled={isLoading || alreadyVoteOn}
        >
          👍{bestObj.rating_plus}
        </button>

        <button
          className="ratings-btn"
          onClick={() => handleVote("rating_neg")}
          disabled={isLoading || alreadyVoteOn}
        >
          👎{bestObj.rating_neg}
        </button>
      </div>
    </li>
  );
}

function Footer() {
  return (
    <footer className="footer">
      &copy; {new Date().getFullYear()} Build by{" "}
      <a href="https://www.linkedin.com/in/carloszaep/">Carlos Paez</a>
    </footer>
  );
}

function Spinning() {
  return (
    <div className="loading-indicator">
      <svg width="40" height="40">
        <circle
          cx="20"
          cy="20"
          r="18"
          fill="none"
          stroke="#ccc"
          strokeWidth="4"
        />
        <circle
          cx="20"
          cy="20"
          r="18"
          fill="none"
          stroke="#4285f4"
          strokeWidth="3"
          strokeDasharray="75, 100"
          strokeDashoffset="25"
          transform="rotate(-90 20 20)"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 20 20"
            to="360 20 20"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </div>
  );
}

export default App;
